import { isValidEmail, isValidText } from '../../../utils/helpers'

export default (operator) => {
  const errors = {}

  if (!isValidEmail(operator.email)) errors.email = 'dashboard_errors_required-field'
  if (!operator.role) errors.role = 'dashboard_errors_required-field'

  if (operator._id) {
    if (operator.name && !isValidText(operator.name)) {
      errors.name = true  // I18n.t('dashboard_errors_not-valid-name')
    }

    if (operator.lastname && !isValidText(operator.lastname)) {
      errors.lastname = true  // I18n.t('dashboard_errors_not-valid-lastname')
    }
  }

  if (operator.role === 'user') {
    if (operator.brands.length < 1) {
      errors.brands = true  // I18n.t('dashboard_errors_required-field')
    }
  } else if (operator.role === 'brandManager') {
    if (!operator.brands.length) errors.brands = true
  } else if (['delegationManager', 'operator'].includes(operator.role)) {
    if (!operator.brands.length || operator.brands.every((item) => !item.delegations || !item.delegations.length)) {
      errors.brands = true
      errors.delegations = true
    }
  }

  return errors
}
